module.exports = __webpack_public_path__ + "static/media/brittany.72ec6525.png";